import { Modal, ModalContent } from "@kirvanobr/modal";
import { styles as s } from "./BannerTop.styles";
import { Banner } from "./components/Banner/Banner";
import { useBannerTop } from "./useBannerTop";

export function BannerTop() {
  const { isOpen, onOpen, onOpenChange, bannerModalUseCasesRender } = useBannerTop();

  return (
    <>
      <Banner onOpen={onOpen} />

      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="auto"
        hideCloseButton
        classNames={{
          base: s().base(),
          backdrop: s().backdrop(),
        }}
      >
        <ModalContent>{bannerModalUseCasesRender()}</ModalContent>
      </Modal>
    </>
  );
}
